export enum EnclosureType {
  CROSSWORD = 'CROSSWORD',
  SUDOKU = 'SUDOKU',
  NEWS = 'NEWS',
  SPORTS_NEWS = 'SPORTS_NEWS',
}
